import Vue from 'vue'
import { language } from '@/infrastructure/Configuration'

const languageWithAmPm = ['en', 'el']

export const formatHour = function (hour, minutes) {
  if (!languageWithAmPm.includes(language)) {
    return hour
  }

  const amPmFormattedHour = hour % 12

  if (!minutes) {
    const ampm = hour >= 12 ? 'pm' : 'am'
    return `${amPmFormattedHour} ${ampm}`
  } else {
    return `${amPmFormattedHour}`
  }
}

export const formatMinutes = function (minutes, hour) {
  let formattedMinutes

  if (!languageWithAmPm.includes(language)) {
    formattedMinutes = minutes ? `${minutes}` : ''
    return formattedMinutes
  }

  const ampm = hour >= 12 ? 'pm' : 'am'
  formattedMinutes = minutes ? `${minutes}` : ''

  return `${formattedMinutes} ${ampm}`
}

Vue.filter('formatHour', formatHour)
Vue.filter('formatMinutes', formatMinutes)
